module.exports = __webpack_public_path__ + "static/media/stoutty-war-ep-art.2e0c57c3.png";